interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";
  className?: string;
}

const LoadingSpinner = ({ size = "md", className }: LoadingSpinnerProps) => {
  const sizes = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-10 w-10",
    xxl: "h-12 w-12",
    xxxl: "h-16 w-16",
  };

  return (
    <div className={"flex items-center justify-center " + className}>
      <div
        className={`${sizes[size]} animate-spin rounded-full border-3 border-gray-300 border-t-primary-600 dark:border-gray-600 dark:border-t-primary-400`}
      />
    </div>
  );
};

export default LoadingSpinner;
